import script from "./PrefectDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./PrefectDashboard.vue?vue&type=script&setup=true&lang=js"

import "./PrefectDashboard.vue?vue&type=style&index=0&id=e16e50ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e16e50ac"]])

export default __exports__